import { NAV_GROUPS } from '@/components/layout/navItems'
import { Card, CardBody, CardHeader } from '@/components/ui/Card'
import { PageHeader } from '@/components/ui/PageHeader'
import { useVenueContext } from '@/routes/venueContext'
import { useVenueStore } from '@/stores/venueStore'

/**
 * 구장 홈 — 기반 구축 단계의 **플레이스홀더**.
 *
 * 구장 하위 화면(대시보드·코트·예약·정산)이 아직 하나도 없어서, 로그인 후 도달할
 * 목적지가 필요하다. 후속 화면이 붙으면 이 화면은 대시보드로 대체되거나 그대로 남는다.
 *
 * 🚨 여기서 서버를 호출하지 않는다 — 구장명은 `VenueLayout` 이 이미 조회해 스토어에 넣어 둔
 * 표시용 미러를 읽는다(같은 EP 를 두 번 부르지 않는다). 아직 없으면 번호로 폴백한다.
 */
export function VenueHomePage() {
  const { venueId } = useVenueContext()
  const venueName = useVenueStore((state) => state.venueName)

  return (
    <>
      <PageHeader
        title={venueName ? `${venueName} 관리` : `구장 #${venueId} 관리`}
        description="앱 기반 구축이 완료되었습니다. 아래 화면들이 순차적으로 열립니다."
      />

      <Card>
        <CardHeader title="준비 중인 화면" description="왼쪽 메뉴에도 같은 순서로 표시됩니다." />
        <CardBody className="space-y-4">
          {NAV_GROUPS.map((group) => (
            <div key={group.label}>
              <p className="text-xs font-medium text-slateish-400">{group.label}</p>
              <ul className="mt-1 space-y-1">
                {group.items.map((item) => (
                  <li
                    key={`${group.label}/${item.path}`}
                    className="flex items-center justify-between text-sm text-slateish-600"
                  >
                    <span>{item.label}</span>
                    <span className="text-xs text-slateish-400">
                      {item.status === 'ready' ? '사용 가능' : '준비 중'}
                    </span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </CardBody>
      </Card>
    </>
  )
}
